export default __webpack_public_path__ + "assets/images/339f6c89dcb6439963c036a85629d8fd.svg";